import React from "react";

import PageHeader from "../../../components/PageHeader";
import RelatorioSaboresToolbar from "../components/RelatorioSaboresToolbar";
import { RelatorioSaboresProvider } from "../context/RelatorioSaboresContext";
import PizzasPorSaborWorkspace from "./PizzasPorSaborWorkspace";

const PizzasPorSabor: React.FC = () => {
  return (
    <main className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
      <RelatorioSaboresProvider>
        <PageHeader
          title="Pizzas por Sabor"
          description=""
          actions={<RelatorioSaboresToolbar variant="exportsOnly" />}
        />
        <PizzasPorSaborWorkspace />
      </RelatorioSaboresProvider>
    </main>
  );
};

export default PizzasPorSabor;
